import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    ascending: true,
    sortKey: 'id',
}

const reportSortingSlice = createSlice({
    name: 'reportSorting',
    initialState,
    reducers: {
        sortingOrderChanged(state, action){
            state.ascending = !state.ascending
        },
        sortingKeyChanged(state, action){
            state.sortKey = action.payload
        }
    }
})

export const { sortingOrderChanged, sortingKeyChanged } = reportSortingSlice.actions;

export default reportSortingSlice.reducer;
